/* @source catpaw @line_count 177 @branch feature/ai-92575103-202604091027 */
import api from '@/api/levelEquity'
import courseCenterApi from '@/api/courseCenter'

export default {
  data() {
    return {
      // 不展示消息提醒的页面
      noMessagePaths: ['/data/assets/battery-panel-detail', '/data/assets/spock-panel-detail'],
      equityPartnerList: [], // 权益商
      equityPopupInfo: {}, // 权益等级
      coursePopupData: {}, // 课程提醒
      unReadList: [], // 未读消息列表
    }
  },

  methods: {
    // 全局弹窗初始化
    // 优先级：培训课程弹窗 > 权益等级弹窗 > 消息弹窗
    async globalDialogInit() {
      if (this.noMessagePaths.includes(this.$route.path)) return

      try {
        // 1. 先尝试展示课程弹窗
        const courseShown = await this.isShowCoursePopup()
        if (courseShown) return

        // 2. 再尝试展示权益等级弹窗
        await this.isShowLevelEquityPopup()
        const { popupWindow, seasonId } = this.equityPopupInfo || {}
        if (!popupWindow) {
          // 3. 最后尝试消息中心弹窗
          return this.showMessage()
        }

        await this.getEquityPartnerList(seasonId)
        this.showLevelEquityPopup()
      } catch (err) {
        this.showMessage()
        this.$addOwlWarn({
          name: `【全局弹窗】初始化失败_${err.message}`,
          msg: { err },
        })
        console.error('globalDialogInit error', err)
      }
    },

    // 路由切换时检查是否有强制课程弹窗需要展示
    async checkForceCourseOnRoute() {
      // 已在课程中心页面，无需弹窗
      if (this.$route.path === '/daxue/course-center') return
      try {
        const params = { platform: 2 }
        const res = await courseCenterApi.queryTrainingPopup(params)
        const data = res?.data
        if (data?.popupType !== 'FORCE' || !data?.classes?.length) return
        this.coursePopupData = data
        this.$refs.CoursePopup && this.$refs.CoursePopup.showForce(data)
      } catch (err) {
        this.$addOwlError({
          name: `【培训课程强制弹窗】路由切换检查失败_${err.message}`,
          msg: { err },
        })
      }
    },

    // 尝试展示课程弹窗，返回是否成功展示
    async isShowCoursePopup() {
      // 已在课程中心页面，无需弹窗
      if (this.$route.path === '/daxue/course-center') return false
      const params = {
        platform: 2,
      }
      try {
        const res = await courseCenterApi.queryTrainingPopup(params)
        this.coursePopupData = res?.data || {}
        const { popupType, classes } = this.coursePopupData
        if (popupType === 'NONE' || !classes?.length) {
          return false
        }
        // FORCE 类型走强制弹窗逻辑（注册路由守卫），REMINDER 类型走普通弹窗
        if (popupType === 'FORCE') {
          this.$refs.CoursePopup && this.$refs.CoursePopup.showForce(this.coursePopupData)
          return true
        }

        // 提醒弹窗
        this.$refs.CoursePopup && this.$refs.CoursePopup.show(this.coursePopupData)
        return true
      } catch (err) {
        this.$addOwlError({
          name: `【培训课程全局弹窗】查询弹窗数据失败_${err.message}`,
          msg: { err },
        })
        return false
      }
    },

    // 判断赛季弹窗是否弹出
    async isShowLevelEquityPopup() {
      try {
        const res = await api.isShowLevelEquityPopup()
        console.log('isShowLevelEquityPopup', res)
        this.equityPopupInfo = res || {}
      } catch (err) {
        this.$addOwlError({
          name: `【等级权益全局弹窗】获取赛季弹窗是否弹出失败_${err.message}`,
          msg: { err },
        })
      }
    },

    // 获取有权限且上个赛季和当前赛季有权益周期的商
    async getEquityPartnerList(seasonId) {
      try {
        const params = { seasonId }
        const res = await api.getEquityPartnerList(params)
        console.log('getEquityPartnerList', res.cooperateDTOList)
        this.equityPartnerList = res.cooperateDTOList || []
      } catch (err) {
        this.$addOwlError({
          name: `【等级权益全局弹窗】获取合作商列表失败_${err.message}`,
          msg: { err },
        })
      }
    },

    // 展示等级权益弹窗
    showLevelEquityPopup() {
      const { supplierCode } = this.equityPartnerList[0] || {}
      const { seasonName, seasonId } = this.equityPopupInfo || {}
      this.$mtd
        .confirm({
          title: '新权益周期开启',
          message: `${seasonName}已开启，期待您解锁更多优质权益`,
          width: '430px',
          closable: false,
          showCancelButton: false,
          okButtonText: supplierCode ? '上一周期回顾' : '查看详情',
          onOk: () => {
            if (supplierCode) {
              setTimeout(() => {
                this.$refs.LevelEquityDialog && this.$refs.LevelEquityDialog.show(seasonId, 'prev')
              })
            } else {
              this.handleUpdateFlag(seasonId, supplierCode)
              if (this.$route.path !== '/level/equity') {
                this.$router.push('/level/equity')
              }
            }
          },
        })
        .catch(() => {})
    },

    handleUpdateFlag(seasonId, supplierCode) {
      const params = {
        seasonId,
        supplierCode,
        update: true,
      }
      api
        .getCurrentSeasonInfo(params)
        .then(() => {})
        .catch(err => {
          this.$addOwlError({
            name: `【等级权益全局弹窗】查看详情-更新标记失败_${err.message}`,
            msg: { params, err },
          })
        })
    },

    // 获取未读消息列表
    async getUserUnreadMessageList() {
      const params = {
        pageNum: 1,
        pageSize: 50,
      }
      try {
        const res = await this.fetch.post('getUserUnreadMessageList', params)
        if (res) {
          this.unReadList = (res.data?.data || []).map(item => ({
            ...item,
            readStatus: item.readStatusDesc,
          }))
        } else {
          this.unReadList = []
        }
      } catch (err) {
        this.$addOwlError({
          name: `【全局弹窗-消息提醒】消息列表获取失败_${err.message}`,
          msg: err,
        })
      }
    },

    // 展示消息弹窗
    async showMessage() {
      await this.getUserUnreadMessageList()
      if (!(this.unReadList || []).length) return
      if (this.noMessagePaths.includes(this.$route.path)) return
      setTimeout(() => {
        this.$refs.MessageCarousel && this.$refs.MessageCarousel.show()
      })
    },
  },
}
